import { createI18n } from 'vue-i18n';

const messages = {
  es: {
    nav: { house: 'La Casa', gallery: 'Galería', location: 'Ubicación', book: 'Reservar Ahora' },
    hero: {
        subtitle: 'Playa El Cuco, El Salvador',
        title: 'Tu refugio privado frente al mar',
        description: 'Experimenta el lujo y la serenidad en Paraíso Marino. El lugar donde el horizonte es tu único límite.',
        btnGallery: 'Explorar Galería',
        btnAvailability: 'Ver Disponibilidad',
        discover: 'Descubrir'
    },
    footer: {
        tagline: 'Tu santuario privado en Playa El Cuco.',
        country: 'El Salvador',
        contact: 'Contacto',
        social: 'Redes Sociales',
        rights: 'Todos los derechos reservados.'
    },
    details: {
        title: 'Tu Estancia en Paraíso Marino',
        description: 'Ubicada en la exclusiva zona de El Esterón, Paraíso Marino es una joya frente al Pacífico. Con un diseño abierto que permite la entrada de la brisa marina, esta propiedad es perfecta para familias grandes o grupos que buscan privacidad total y acceso directo a una de las mejores playas de El Salvador.',
        guests: 'Huéspedes',
        rooms: 'Habitaciones',
        beds: 'Camas',
        baths: 'Baños',
        amenitiesTitle: 'Lo que ofrece este lugar',
        beachfront: 'Frente al mar',
        pool: 'Piscina privada',
        kitchen: 'Cocina equipada',
        wifi: 'Wifi incluido',
        parking: 'Estacionamiento gratis',
        ac: 'Aire acondicionado',
        security: 'Seguridad 24/7',
        beachAccess: 'Acceso a la playa',
        beachAccessDesc: 'Directo desde el jardín privado.',
        poolDesc: 'Disponible todo el año con vista al mar.',
        amenitiesLabel: 'Comodidades',
    },
    booking: {
        title: 'Reserva tu estancia',
        checkIn: 'Llegada',
        checkOut: 'Salida',
        guests: 'Huéspedes',
        button: 'Reservar ahora',
        disclaimer: 'No se realizará ningún cargo todavía',
        price: 'por noche',
        total: 'Total',
        adults:'Adultos',
        children:'Niños',
        selectDates: 'Seleccionar Fechas',
        nights: 'noche | noches'
    },
    gallery: {
        title: 'Explora Paraíso Marino',
        subtitle: 'Un vistazo a tu próximo destino',
        viewAll: 'Ver todas las fotos'
    },
    galleryList: {
        room1: 'Habitación Suite',
        pool: 'Piscina y Deck',
        room2: 'Dormitorio Familiar',
        view: 'Vista a la Playa',
        room3: 'Confort y Estilo',
        patio: 'Patio y Jardines'
    },
    checkout: {
        title: 'Confirmar Reserva',
        cardInfo: 'Información de Pago',
        cardHolder: 'Nombre en la tarjeta',
        cardNumber: 'Número de tarjeta',
        payButton: 'Pagar ahora',
        secureText: 'Pago seguro encriptado',
        totalPayment: 'Total a pagar',
        holderName: 'Nombre del Titular',
        holderNamePH: 'Como aparece en la tarjeta',
        cardNumber: 'Número de Tarjeta',
        expiration: 'Expiración',
        payButton: 'Pagar ahora',
        successTitle: '¡Reserva Confirmada!',
        successMsg: 'El pago ha sido procesado exitosamente. Te esperamos en el paraíso.',
        close: 'Cerrar'
    },
    reviews: {
        title: 'Experiencias de nuestros huéspedes',
        subtitle: 'Lo que dicen de nosotros'
    },
  },
  en: {
    nav: { house: 'The House', gallery: 'Gallery', location: 'Location', book: 'Book Now' },
    hero: {
        subtitle: 'El Cuco Beach, El Salvador',
        title: 'Your private beachfront sanctuary',
        description: 'Experience luxury and serenity at Paraíso Marino. Where the horizon is your only limit.',
        btnGallery: 'Explore Gallery',
        btnAvailability: 'Check Availability',
        discover: 'Discover'
    },
    footer: {
        tagline: 'Your private sanctuary at El Cuco Beach.',
        country: 'El Salvador',
        contact: 'Contact',
        social: 'Social Media',
        rights: 'All rights reserved.'
    },
    details: {
        title: 'Your Stay at Paraíso Marino',
        description: 'Located in the exclusive area of El Esterón, Paraíso Marino is a gem facing the Pacific. With an open design that allows the sea breeze in, this property is perfect for large families or groups looking for total privacy and direct access to one of the best beaches in El Salvador.',
        guests: 'Guests',
        rooms: 'Bedrooms',
        beds: 'Beds',
        baths: 'Baths',
        amenitiesTitle: 'What this place offers',
        beachfront: 'Beachfront',
        pool: 'Private pool',
        kitchen: 'Full kitchen',
        wifi: 'High-speed Wifi',
        parking: 'Free parking',
        ac: 'Air conditioning',
        security: '24/7 Security',
        beachAccess: 'Beach Access',
        beachAccessDesc: 'Directly from the private garden.',
        poolDesc: 'Available all year with ocean view.',
        amenitiesLabel: 'Amenities',
    },
    booking: {
        title: 'Book your stay',
        checkIn: 'Check-in',
        checkOut: 'Check-out',
        guests: 'Guests',
        button: 'Reserve now',
        disclaimer: 'You won\'t be charged yet',
        price: 'per night',
        total: 'Total',
        adults:'Adults',
        children:'Childrens',
        selectDates: 'Select Dates',
        nights: 'night | nights'
    },
    gallery: {
        title: 'Explore Paraíso Marino',
        subtitle: 'A glimpse into your next destination',
        viewAll: 'View all photos'
    },
    galleryList: {
        room1: 'Master Suite',
        pool: 'Pool & Deck',
        room2: 'Family Bedroom',
        view: 'Beach View',
        room3: 'Comfort & Style',
        patio: 'Patio & Gardens'
    },
    checkout: {
        title: 'Confirm Booking',
        cardInfo: 'Payment Information',
        cardHolder: 'Cardholder Name',
        cardNumber: 'Card Number',
        payButton: 'Pay Now',
        secureText: 'Secure encrypted payment',
        totalPayment: 'Total to pay',
        holderName: 'Cardholder Name',
        holderNamePH: 'As it appears on card',
        cardNumber: 'Card Number',
        expiration: 'Expiration',
        payButton: 'Pay Now',
        successTitle: 'Booking Confirmed!',
        successMsg: 'The payment has been processed successfully. We look forward to seeing you in paradise.',
        close: 'Close'
    },
    reviews: {
        title: 'Guest Experiences',
        subtitle: 'What they say about us'
    }
  }
};

export const i18n = createI18n({
  legacy: false, // Usar Composition API
  locale: 'es',
  fallbackLocale: 'en',
  messages,
});